import { Backdrop, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useUserState } from '../../../context/UserContext';
import { debugLog } from '../../../common/debugUtilities';

const Loading = (props) => {
  const { authenticationInProcess } = useUserState();
  const {isLoading} = props;
  useEffect( ()=>{
      debugLog('Authentication in process:', authenticationInProcess);
  },[authenticationInProcess]);
  useEffect ( ()=>{
    debugLog('isLoading:', isLoading);
  },[]);
  return (
    <Backdrop
        open={authenticationInProcess || isLoading}
        //open={true}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 999 }}
    >
      <CircularProgress sx={{ color: 'secondary' }} />
    </Backdrop>
  );
};

export default Loading;
